import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import { useParams } from 'react-router-dom'

import { setUser } from '@h2/common/actions/setUser'
import { user as getUser } from '@h2/common/selectors/user'

import { loadGame, setDataLoaded } from '../../actions/early/earlyListing'

const EarlyLoader = () => {
  /*
   *  const { loadingState } = useSelector(state => {
   *  console.log(state.early.gameboard.activityLog)
   *
   *  return state.early.gameboard.activityLog
   *  })
   */
  const loadingState = 3
  const userProfile = useSelector(getUser)

  if (!userProfile) {
    //if not logged in, we will redirect back to the listing
    window.location.href = '/ladder'
  }

  const { gameId } = useParams()
  const [resolution, setResolution] = useState({
    resolved: false,
    result: null,
    error: null
  })
  const dispatchIt = useDispatch()

  useEffect(() => {
    const theAction = Promise.all([
      import(/* webpackChunkName: "earlyroutes" */ './EarlyRoutes'),
      dispatchIt(loadGame(gameId))
    ])
    const doAction = async () => {
      const result = await theAction

      dispatchIt(
        setUser({
          ...userProfile,
          earlyDashboardActive: true
        })
      )

      try {
        dispatchIt(setDataLoaded(true))
        setResolution({
          resolved: true,
          result,
          error: null
        })
      } catch (error) {
        setResolution({
          resolved: true,
          error,
          result: null
        })

        if (
          dynamicValues.environment === 'production' ||
          dynamicValues.environment === 'staging'
        ) {
          window.location.href = '/ladder'
        }
      }
    }

    return doAction()
  }, [gameId])

  const outputText = () => {
    switch (loadingState) {
      case 1:
        return t`Getting your stuff from the server`
      case 2:
        return t`Finished getting everything, setting it up`
      case 3:
        return t`Almost finished setting up, just a little more to do`
      default:
        return t`This may take a little bit...`
    }
  }
  const loadingSeq = () => {
    return (
      <div className="loading">
        <div className="loading-character"></div>
        <div className="text-holder">
          <h3>{t`Loading, please wait...`}</h3>
          <div>
            <i className="fal fa-spinner fa-pulse fa-fw"></i> {outputText()}
          </div>
        </div>
      </div>
    )
  }
  const { resolved, result } = resolution

  //console.log(result)

  if (resolved) {
    const UpTheLadder = result?.length && result[0].default

    return <UpTheLadder />
  }

  return loadingSeq()
}

export { EarlyLoader }
